<template>
  <div>

    <b-card class="mt-2 position-relative">

      <b-card-title class="text-primary">Connexion à l'application</b-card-title>

      <hr>

      <video
          :key="currentVideo"
          controls
          autoplay
          class="w-100"
      >
        <source
            :src="require(`@/assets/videos/Part1.mp4`)"
            type="video/mp4"
        />
        Votre navigateur ne supporte pas la lecture vidéo.
      </video>
    </b-card>


  </div>
</template>



<script>
import { BCard } from 'bootstrap-vue'

export default {
  components: {
    BCard,
  },
  data() {
    return {
      currentVideo: 'Part1.mp4',
    }
  },
  methods: {
    playVideo(video) {
      this.currentVideo = video
    },
    closeVideo() {
      this.currentVideo = null
    },
  },
}

</script>

<style>
  .video-links {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .video-links li {
    padding: 12px 16px;
    cursor: pointer;
    border-radius: 6px;
    transition: background 0.2s ease;
    font-weight: 500;
    margin-bottom: 10px; /* 👈 ESPACE ENTRE LES LI */
  }

  .video-links li:hover {
    background: rgba(0, 92, 185, 0.05);
  }

  .video-links li.active {
    background: rgba(0, 92, 185, 0.05);
    color: #005CB9;
  }

  .close-video-btn {
    position: absolute;
    top: -10px;   /* remonte au-dessus de la card */
    right: -10px; /* sort à droite */
    border-radius: 50%;
    width: 30px;
    height: 30px;
    padding: 0;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
  }

  .close-video-btn:hover {
    transform: scale(1.1);
  }
</style>